import React from 'react'
import { Link } from 'react-router-dom'
import './Footer.css'

function Footer({ user, login, logout }) {
    return (
        <footer className="home_footer">
            <div className='left_footer'>
                <div>
                    <Link to="/" className="name" >
                        <img src="Images/tubelink-logo-with-text-2.png" alt="tubelink" />
                    </Link>
                    {/* Twitter Logo */}
                </div>
                <div className="copyright">
                    © {new Date().getFullYear()} TubeLink
                </div>
            </div>
            <div className="footer_links">
                <div className='footer_start'>
                    <h1>NO MORE TIME WASTE!</h1>
                    <span className='get_started footer_btn' onClick={() => { user ? window.location = "/profile" : login() }}>Get Started</span>
                </div>
                <div className='footer_nav'>
                    <div className="product_wrapper">
                        <h2>
                            Product
                        </h2>
                        <div className='product_wrapper_div'>
                            <span><Link to="/" >Home</Link></span>
                            <span><Link to="/pricing" >Pricing</Link></span>
                            {!user ? <span onClick={login}>Get Started</span> : <>
                                <span>
                                    <Link to="/profile">Profile</Link>
                                </span>
                                <span onClick={logout}>
                                    Logout
                                </span>
                            </>}
                        </div>
                    </div>
                    <div className="company_wrapper">
                        <h2>
                            Company
                        </h2>
                        <div className='company_wrapper_div'>
                            <span>
                                <Link to="/terms">Terms & Conditions</Link>
                            </span><span>
                                <Link to="/policy">Privacy & Policy</Link>
                            </span><span>
                                <Link to="/Contact">Contact</Link>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </footer >
    )
}

export default Footer